import * as api from '../api/project';
import { asyncAction } from './common';

export const fetchOptions = () => asyncAction('FETCH_PROJECT_OPTIONS', api.fetchOptions);

export const setUserZoneId = (zoneId) =>
  asyncAction('SET_USER_ZONE_ID', api.updateOptions({ timezone: zoneId }));

export const checkActualization = () =>
  asyncAction('FETCH_PROJECT_ACTUALIZATION', api.checkActualization());

export const setTenantId = (tenantId) => ({
  type: 'SET_TENANT_ID',
  tenantId,
});

export const fetchConfig = () => async (dispatch) => {
  // TODO добавить проверку на environment для корректного запуска из разных окружений
  const config = await api.fetchConfig();

  dispatch({
    type: 'FETCH_CONFIG_SUCCESS',
    backendUrl: config.BACKEND_URL,
    docsUrl: config.DOCS_URL,
  });
};
